// import STEMONLogo from '../../img/Main-logo.png';
import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice';
import { Link } from 'react-router-dom';

const IframeScope = styled.div`
    justify-self: center; 
    align-self: center;
    margin-top:10px;
`


const Footer = () => {
    var currentTime = new Date();
    var year = currentTime.getFullYear()
    const url =/STEMON/
  return (
    <div className="mt-5">
            <footer className="bg-gray-100">
        <div className="pt-4 sm:pt-10 lg:pt-12 pb-16">
          <div className="max-w-screen-2xl px-4 md:px-8 mx-auto">
              <div className="grid grid-cols-4 gap-4 sm:grid-cols-4 md:grid-cols-12">
                  <div className="col-span-4 gap-4">
                      <div className="lg:-mt-2 mb-4">
                        <a href="/STEMON/" className="inline-flex items-center text-orange-400 text-xl md:text-2xl font-bold gap-2 " aria-label="logo">
                            STEMON
                        </a>
                      </div>
                      <div className='border-solid rounded border p-3'>
                          <p>〒780-0033</p>
                          <p>高知県高知市西秦泉寺73-1ソワール西秦Ⅰ</p>
                          <p>TEL：088-802-8739</p>
                      </div>
                      <p className='pl-4 mt-2'><Link to={ url + 'Policy'}>個人情報保護方針</Link></p>
                  </div>

                  <IframeScope className="col-span-4">
                      <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1397.612801265094!2d133.53316088224463!3d33.57669630042055!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe88c9bd963cde09f!2z44K544OG44Oi44Oz56em5qCh!5e0!3m2!1sja!2sjp!4v1646983051220!5m2!1sja!2sjp"  loading="lazy"></iframe>
                  </IframeScope>

                 
              </div>
          </div>
        </div>

        <div className="bg-gray-100">
          <div className="max-w-screen-2xl px-4 md:px-8 mx-auto">
            <div className="flex justify-between items-center gap-4 py-8">
              <span className="text-gray-400 text-sm"> © {year} - Present Flowrift. All rights reserved. </span>

              
              <div className="flex gap-4">
                <a href="https://www.instagram.com/stemon_kochi/" target="_blank" className="text-gray-400 hover:text-gray-500 active:text-gray-600 transition duration-100">
                  <svg className="w-5 h-5" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
              </div>
              
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
export default Footer;